module.exports = "https://web-assets.ifttt.com/packs/media/service_icons/instagram-8e9ded04.svg";